import React from 'react';
import omit from 'lodash/omit';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';

const FormHttpBtn = (props) => {
  const {
    res,
    className = '',
    children,
    icon,
    disabled,
  } = props;

  const c = ['btn', className].filter((s) => s).join(' ');
  const p = omit(props, [
    'res',
    'className',
    'children',
    'icon',
    'disabled',
  ]);

  return (
    <button
      {...p}
      className={c}
      disabled={disabled || res.status === 'pending'}
    >
      {icon && (
        <FA
          icon={res.status === 'pending' ? faSpinner : icon}
          fixedWidth
          pulse={res.status === 'pending'}
        />
      )}
      {children && ' '}
      {children}
    </button>
  );
};

export default FormHttpBtn;
